import { clsx } from "clsx";
import { restomagSlides } from "../data.ts";
import { useCarousel } from "../hooks/useCarousel.ts";
import { withUtm, MAIN_ORIGIN } from "../../../config/crossSiteNav.ts";
import { IconArrowRight } from "./icons.tsx";

const CTA_HREF = withUtm(`${MAIN_ORIGIN}/`, "events", "hero_carousel");

export function RestoMagShowcase() {
  const { index, setIndex, pause, resume } = useCarousel(restomagSlides.length, 4000);

  return (
    <div
      className="w-full max-w-[320px] rounded-2xl border border-white/[.12] bg-[rgba(20,18,16,.55)] p-3 backdrop-blur-[10px]"
      onMouseEnter={pause}
      onMouseLeave={resume}
      aria-roledescription="carousel"
      aria-label="RestoMag showcase"
    >
      <span className="block px-1 pb-2 font-mono text-[10px] uppercase tracking-[.2em] text-flame">
        Powered by RestoMag
      </span>

      {/* Slides */}
      <div className="relative h-[200px] overflow-hidden rounded-xl">
        {restomagSlides.map((slide, i) => (
          <div
            key={slide.img}
            role="group"
            aria-roledescription="slide"
            aria-label={`${i + 1} of ${restomagSlides.length}`}
            aria-hidden={i !== index}
            className={clsx(
              "absolute inset-0 transition-opacity duration-700",
              i === index ? "opacity-100" : "opacity-0",
            )}
          >
            <img src={slide.img} alt="" loading={i === 0 ? "eager" : "lazy"} className="h-full w-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent" />
            <p className="absolute bottom-3 left-3 right-3 font-archivo text-lg font-bold leading-tight text-white">
              {slide.line}
            </p>
          </div>
        ))}
      </div>

      {/* Dots + CTA */}
      <div className="flex items-center justify-between px-1 pt-3">
        <div className="flex gap-1.5" role="tablist" aria-label="Choose slide">
          {restomagSlides.map((s, i) => (
            <button
              key={s.img}
              type="button"
              role="tab"
              aria-selected={i === index}
              aria-label={`Slide ${i + 1}`}
              onClick={() => setIndex(i)}
              className="flex items-center justify-center py-[19px] px-1.5"
            >
              <span
                aria-hidden
                className={clsx(
                  "block h-1.5 rounded-full transition-all",
                  i === index ? "w-5 bg-flame" : "w-1.5 bg-white/30",
                )}
              />
            </button>
          ))}
        </div>
        <a
          href={CTA_HREF}
          className="inline-flex items-center gap-1.5 text-sm font-bold text-white no-underline hover:text-flame"
        >
          Discover RestoMag <IconArrowRight size={15} />
        </a>
      </div>
    </div>
  );
}
